import { useRef } from "react";
import {
  DlfMatcherTypes,
  getDlfMatcherTypesDisplayValue,
  isDlfMatcherTypes,
} from "../../types/rules/DlfMatcherTypes";
import { useDropdown } from "../hooks/useDropdown";
import Icon from "../Icon";
import { Label, LabelProps } from "./Label";
import "../../styles/inputGroup/dropdownLabel.css";

export { DlfTypeLabel };
type Props = {
  /**
   * Current DlfMatcher discriminator.
   */
  discriminator: DlfMatcherTypes;
  onMatcherChange(newType: DlfMatcherTypes): void;
} & LabelProps;
const types: DlfMatcherTypes[] = [
  "F_REGEX",
  "F_KEYVALUE",
  "F_FUZZY",
  "F_DEFAULT",
];
/**
 * An <InputGroup/> label element that allows for the DlfType to be changed
 */
const DlfTypeLabel = (props: Props) => {
  const containerRef = useRef<HTMLLabelElement>(null);

  const { isOpen, renderTooltip, setOpen, triggerBounds, triggerProps } =
    useDropdown({
      containerRef,
      options: types.reduce((prev, curr) => {
        //@ts-expect-error
        prev[curr] = getDlfMatcherTypesDisplayValue(curr as DlfMatcherTypes);
        return prev;
      }, {}),
      selected: props.discriminator,
      onSelect: (val) => {
        if (isDlfMatcherTypes(val)) {
          props.onMatcherChange(val);
        }
      },
    });

  return (
    <Label {...props} className={"dropdownLabel"} ref={containerRef}>
      {props.children}
      <Icon
        {...triggerProps}
        onClick={() => setOpen(!isOpen)}
        altText={"Change Type"}
        icon={"chevron-down"}
      />
      {isOpen && renderTooltip()}
    </Label>
  );
};
